import React from 'react';

interface MenuPathProps {
  children: React.ReactNode;
}

const MenuPath: React.FC<MenuPathProps> = ({ children }) => (
  <code className="font-mono text-[12px] bg-surface-secondary border border-border rounded-[4px] px-[6px] py-[1px] text-content-primary [overflow-wrap:anywhere]">
    {children}
  </code>
);

export default MenuPath;
